<template>
  <div class="main_home">
    <div>
        <div class="main_header">
            <h1 style="font-size:30px;text-align: center;width: 100%;margin: 0 auto;padding: 0;background: #0072ff;line-height: 70px;color: white;">
                {{ company.name }}
            </h1>
        </div>
        <div class="main_title" style="margin-top:40px;">
            <ul style="overflow:hidden;">
                <li>
                    <el-image fit="cover"  class="main_title_img" :src="require('@/assets/login_ico.png')">
                    </el-image>
                </li>
                <li>
                    <span>
                        用户登录
                    </span>
                </li>
            </ul>
        </div>
        <div class="main_content" style="margin-top:50px;">
            <ul style="display:grid;">
                <li style="width:100%;height:50px;">
                    <a-input addon-before="账号" @pressEnter="login" type="email" v-model="username" placeholder="请输入用户名 / 邮箱" size="large" style="height:50px;font-size:20px;">
                        <a-icon type="user" />
                    </a-input>
                </li>
                <li style="width:100%;height:50px;">
                    <a-input-password v-model="password" @pressEnter="login" addon-before="密码" placeholder="请输入密码" size="large" style="height:50px;font-size:20px;">
                        <a-icon type="user" />
                    </a-input-password >
                </li>
                <li>
                    <router-link to="/user/forgetpassword" style="color:#333;">
                        <a>忘记密码?</a>
                    </router-link>
                </li>
                <li style="width:100%;height:70px;">
                    <a-button :loading="login_loading" @click="login" style="border-radius:5px;background:#1890ff;display:block;width:100%;height:50px;line-height:50px;color:white;font-size:20px;text-align:center;">
                        登录
                    </a-button>
                </li>
            </ul>
        </div>
    </div>
    <div class="register_footer">
        <ul style="width:100%;height:100%;">
            <li style="float:left;height:100%;width:40%;margin-left:10%;">
                <router-link to="/home" class="member_home_a">
                    <ul style="text-align:center;">
                        <li>
                            <el-image fit="cover"  class="member_quit_img" :src="require('@/assets/account_login.png')">
                                
                            </el-image>
                        </li>
                        <li>
                            <a class="member_quit_a">
                                会员中心
                            </a>
                        </li>
                    </ul>
                </router-link>
            </li>
            <li style="float:right;height:100%;width:40%;margin-right:10%;">
                <router-link to="/" class="member_home_a">
                    <ul style="text-align:center;">
                        <li>
                            <el-image fit="cover"  class="member_quit_img" :src="require('@/assets/quit.png')">
                                
                            </el-image>
                        </li>
                        <li>
                            <a class="member_quit_a">
                                安全退出
                            </a>
                        </li>
                    </ul>
                </router-link>
            </li>
        </ul>
    </div>
  </div>
</template>

<script>

import request from '../../api/request'
import company_model from '../../model/company'
import watermark from 'watermark-dom'

export default {
    name: 'UserLogin',
    head: {
        title: "用户登录",
        meta:[
            { name: 'description', content: '用户登录'}
        ]
    },
    data() {
        return {
            username: "",
            password: "",
            login_loading: false,
            company: company_model,
        }
    },
    methods: {
        fetch_company() {
            let company_info_resp = request.company.company()
            company_info_resp.then((response) => {
                if (response.status == 200 && response.data.code == 0) {
                    if (response.data.data) {
                        this.company = response.data.data
                    }
                }
            })
        },
        login() {
            
            if (
              !this.username || 
              !this.password
            ) {
                this.$message.error("用户名和密码必须填写!!!")
            }
            else {
                this.login_loading = true
                let resp = request.site_user.login(this.username, this.password)
                resp.then((response) => {
                    this.login_loading = false
                    if (response.status == 200 && response.data.code == 0) {
                        var success_message = response.data.message
                        if (!success_message) {
                            success_message = "注册成功"
                        }
                        this.$message.success(success_message)
                        this.$router.push('/order/list')
                    }
                    else {
                        var failed_message = response.data.message
                        if (!failed_message) {
                            failed_message = "注册失败"
                        }
                        this.$message.error(failed_message)
                    }
                })
                .catch((error) => {
                    this.login_loading = false
                    if (error) {
                        this.$error({
                            title: "请求失败，请联系管理员",
                            content: String(error),
                        });
                    }
                })
            }
            
        },
        load() {
            try {
                watermark.remove()
            }
            catch (err) {
                console.log()
            }
            this.fetch_company()
        }
    },
    created() {
        this.load()
    }
}
</script>

<style>

html {
  margin: 0;
  padding: 0;
}

body {
  margin: 0; 
  padding: 0;
}

ul {
  list-style: none;
}

.main_home {
  height: 100%;
  margin: 0;
  padding: 0;
}

.main_header {
    text-align: center;
    width: 100%;
    margin: 0 auto;
    padding: 0;
}

.main_title {
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 20px;
    height: 50px;
}

.main_title ul {
    margin: 0 auto;
    padding: 0;
    height: 100%;
}


.main_title ul li {
    height: 100%;
    margin: 0 auto;
    padding: 0;
    float: left;
}

.main_title ul li:last-child {
    margin-left: 20px;
}

.main_title_img {
    width: 50px;
    height: 50px;
}

.main_title ul > li > span {
    display: block;
    margin: 0 auto;
    padding: 0;
    line-height: 50px;
    font-size: 20px;
}

.main_content > ul {
    margin: 0;
    padding: 0;
    height: 210px;
}


</style>
